import React from 'react';
import { Route, Switch, routerRedux } from 'dva/router';
import dynamic from 'dva/dynamic';
import App from './routes/app';
import Routes from './routes';

const { ConnectedRouter } = routerRedux;

function RouterConfig({ history, app }) {
  const error = dynamic({
    app,
    component: () => import('./routes/error'),
  });

  return (
    <ConnectedRouter history={history}>
      <App>
        <Switch>
          {
            Object.values(Routes).map(({ path, ...dynamics }, key) => (
              <Route key={key} exact strict path={path} component={dynamic({ app, ...dynamics })} />
            ))
          }
          <Route component={error} />
        </Switch>
      </App>
    </ConnectedRouter>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/router.js